import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { ZebraPrinterStatusDto } from '../models/ZebraPrinterStatusDto';
import { ZebraPrintDocumentDto } from '../models/ZebraPrintDocumentDto';
import { ZebraPrintRequestDto } from '../models/ZebraPrintRequestDto';

@Injectable({
    providedIn: 'root',
})
export class DistributedPrintingService extends BaseService {

    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl_v2 + "DistributedPrinting/";
    }
    private testSubject = new BehaviorSubject('Value 1');
    test$: Observable<string> = this.testSubject.asObservable();

    getAgentDownload(): Observable<any> {
        let url_call: string = this.baseUrl + "agent/download";
        return this._http.get(url_call, { responseType: 'blob' });
    }

    getPrinterStatuses(enabled: boolean): Observable<any> {
        let url_call: string = this.baseUrl + "statuses/" + enabled;
        return this.get(url_call);
    }

    getPrinterTemplates(enabled: boolean): Observable<any> {
        let url_call: string = this.baseUrl + "templates/" + enabled;
        return this.get(url_call);
    }

    updatePrinterStatus(model: ZebraPrinterStatusDto): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "update/status";
        return this._http.post(url_call, model, { headers });
    }

    printRequest(model: ZebraPrintRequestDto): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "print";
        return this._http.post(url_call, model, { headers });
    }
}
